<div class="content">
    <div class="table-container">
      <div class=table>
        <div class="table-area">
          <table mat-table [dataSource]="reportData" class="mat-elevation-z8">
            <ng-container matColumnDef="animalId">
              <th mat-header-cell *matHeaderCellDef> Identificação Animal </th>
              <td mat-cell *matCellDef="let element"> {{ element.animalId }} </td>
            </ng-container>

            <ng-container matColumnDef="breed">
              <th mat-header-cell *matHeaderCellDef> Raça </th>
              <td mat-cell *matCellDef="let element"> {{ element.breed }} </td>
            </ng-container>

            <ng-container matColumnDef="sex">
              <th mat-header-cell *matHeaderCellDef> Sexo </th>
              <td mat-cell *matCellDef="let element"> {{ element.sex }} </td>
            </ng-container>

            <ng-container matColumnDef="maturity">
              <th mat-header-cell *matHeaderCellDef> Maturidade (meses) </th>
              <td mat-cell *matCellDef="let element"> {{ element.maturity }} </td>
            </ng-container>

            <ng-container matColumnDef="birth">
              <th mat-header-cell *matHeaderCellDef> Data de Nascimento </th>
              <td mat-cell *matCellDef="let element"> {{ element.birth }} </td>
            </ng-container>

            <ng-container matColumnDef="earring">
              <th mat-header-cell *matHeaderCellDef> Data de Brincagem </th>
              <td mat-cell *matCellDef="let element"> {{ element.earring }} </td>
            </ng-container>

            <ng-container matColumnDef="rating">
              <th mat-header-cell *matHeaderCellDef> Classificação </th>
              <td mat-cell *matCellDef="let element"> {{ element.rating }} </td>
            </ng-container>

            <ng-container matColumnDef="inl">
              <th mat-header-cell *matHeaderCellDef> INL </th>
              <td mat-cell *matCellDef="let element"> {{ element.inl }} </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"> </tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="3"> Nenhum registro encontrado </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
